 <p-multiSelect 
    [options]="partnership"
    [(ngModel)]="partnershipSelected"
    [defaultLabel]="processing ? 'Loading..' : defaultLabel"
    [filterPlaceHolder]="filterPlaceHolder"
    [disabled]="disabled || processing"
    [maxSelectedLabels]="maxSelectedLabels"
    (onChange)="change($event.value)"
    (onBlur)="blur()"
    optionLabel="RelationshipName"
    selectionLimit="1"
    [readonly]="readOnly">
  </p-multiSelect>